/* eslint-disable no-unused-vars */
import React from 'react';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { Typography, FormControl } from '@mui/material';
import './styles.scss';

export default function TextArea(props) {
  const {
    name,
    value,
    onChange,
    className = '',
    label,
    required,
    maxlen = 1000,
    variant = 'outlined',
    error = null,
    size = 'small',
    ...others
  } = props;

  return (
    <FormControl className="formControl" variant={variant}>
      {label && (
        <Typography
          component="p"
          className={required ? 'inputLabel required' : 'inputLabel'}
        >
          {label}
        </Typography>
      )}
      <TextareaAutosize
        aria-label="text-area"
        minRows={4}
        className={`textAreaStyle ${className}`}
        name={name}
        value={value}
        onChange={onChange}
        maxLength={maxlen}
        {...others}
      />
      {error && <Typography className="errorText">{error}</Typography>}
    </FormControl>
  );
}
